// src/utils/fetchInvoiceProjectData.js
import projectsApi from "../api/projects";

let allProjectsCache = null;

const fetchAllProjects = async () => {
    if (allProjectsCache) {
        console.log("Using cached projects");
        return allProjectsCache;
    }

    const allProjectsResponse = await projectsApi.getAllProjects("active");
    if (!allProjectsResponse.ok || !allProjectsResponse.data) {
        throw new Error("Failed to fetch All Projects");
    }

    allProjectsCache = allProjectsResponse.data;
    console.log(`Fetched ${allProjectsCache.length} projects from API`);
    return allProjectsCache;
};

export const fetchInvoiceProjectData = async (limit = 100, user = null) => {
    try {
        const allProjects = await fetchAllProjects();

        const termsResponse = await projectsApi.getProjectTerms();
        if (!termsResponse.ok || !termsResponse.data) {
            throw new Error("Failed to fetch invoice terms");
        }

        const terms = termsResponse.data.slice(0, limit);

        const mergedData = [];
        const failedRequests = [];

        await Promise.all(
            terms.map(async (term) => {
                try {
                    const matchingProject = allProjects.find(
                        (project) =>
                            project.project_king_id === term.projects_invoice_terms_project_id &&
                            (!user || project.projects_employees_employee_name === user.name)
                    );

                    if (matchingProject) {
                        mergedData.push({
                            invoice: term,
                            project: matchingProject,
                        });
                    } else {
                        console.error(`No matching project found for ID ${term.projects_invoice_terms_project_id}`);
                        failedRequests.push(term.projects_invoice_terms_project_id);
                    }
                } catch (error) {
                    console.error(`Error processing project ID ${term.projects_invoice_terms_project_id}:`, error);
                    failedRequests.push(term.projects_invoice_terms_project_id);
                }
            })
        );

        const successCount = mergedData.length;
        const failedCount = failedRequests.length;
        console.log(`Summary: ${successCount} requests succeeded, ${failedCount} requests were rejected.`);

        // Sort mergedData by `projects_invoice_terms_planned_for` in ascending order
        mergedData.sort((a, b) =>
            new Date(a.invoice.projects_invoice_terms_planned_for) - new Date(b.invoice.projects_invoice_terms_planned_for)
        );

        return mergedData;
    } catch (error) {
        console.error("Error in fetchInvoiceProjectData:", error);
        return [];
    }
};
